export function handleRightClick(event) {
    event.preventDefault()
  }

export const handleKeyDown = (e) => {
    document.onkeydown = (e) => {
      // Disable F12, Ctrl + Shift + I, Ctrl + Shift + J, Ctrl + U
      if (
        e.key === 'F12' ||
        ctrlShiftKey(e, 'I') ||
        ctrlShiftKey(e, 'J') ||
        ctrlShiftKey(e, 'C') ||
        (e.ctrlKey && e.key === 'KeyU'.charCodeAt(0))
      ) {
        return (<><Router /></>)
      }
    }
  }